window.addEventListener('DOMContentLoaded', () => {
    const grids = document.querySelectorAll('.content .grid');

    // Color grids by the dataset of the element in it
    document.querySelectorAll('[data-grid-color]')?.forEach(el => el.closest('.grid')?.classList.add(`grid--fullbg--colored-${el.dataset.gridColor}`));
    document.querySelectorAll('[data-fullbg="true"]')?.forEach(el => el.closest('.grid')?.classList.add(`grid--fullbg`));
    document.querySelectorAll('[data-fullwidth="true"]')?.forEach(el => el.closest('.grid')?.classList.add('grid--fullwidth'));

    // Give the footer a fullbg background based on the last grid
    const lastGrid = [...grids].pop();

    if(lastGrid.querySelector('[data-grid-color][data-fullbg="true"]') || (lastGrid.classList.contains('fullbg--colored'))) {

        document.querySelector('.twz-footer').classList.add(`grid--fullbg`);

        if (lastGrid.querySelector('[data-grid-color]')) {
            document.querySelector('.twz-footer').classList.add(`grid--fullbg--colored-${lastGrid.querySelector('[data-grid-color]').dataset.gridColor}`);
        } else {
            const classes = Array.from(lastGrid.classList);
            const checkColor = (element, index) => {
                return element.includes('grid--fullbg--colored-');
            }
            const color = classes.find(checkColor).replace('grid--fullbg--colored-', '');
            document.querySelector('.twz-footer').classList.add(`grid--fullbg--colored-${parseInt(color)}`);
        }
    }
});